import React, { Component} from 'react';
import { observer, inject  } from "mobx-react";

export default inject("data")(observer(class Modal extends Component  {

    constructor(props) {
        super(props);

        this.state = {
            processingAction : false
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.finishProcessing !== this.props.finishProcessing) {
            this.setState({ processingAction: this.props.finishProcessing });
        }
    }

    disableButtons() {
        this.setState({
            processingAction : true
        })
    }

    processOk() {
    	this.disableButtons();
    	let valid = this.props.okAction()

    	if (valid === false) {
        	this.setState({
        		processingAction : false
      		})
      	}
    }

    handleBackdropClick = (e) => {
        if (this.props.disableBackdropClose) return;
        // Only close if clicking on the backdrop (not the modal content)
        if (e.target === e.currentTarget && this.props.cancelAction) {
            this.props.cancelAction();
			return;
        }
		if (e.target === e.currentTarget && this.props.onClose) {
            this.props.onClose();
        }
    }

    handleModalContentClick = (e) => {
        // Prevent event bubbling to avoid closing when clicking inside modal
        e.stopPropagation();
    }

	countButtons() {
		return [
			this.props.cancelAction,
			this.props.secondaryAction,
			this.props.secondaryActions,
			this.props.okAction || this.props.okIsSubmit
		].filter(Boolean).length;
	}

	get buttonCount() {
		return this.countButtons();
	}

    render() {
        return <div className="modal d-block" tabIndex="-1" role="dialog" onClick={this.handleBackdropClick}>
        	<div className="modal-dialog" role="document" style={this.props.centered ? {position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", margin: 0, maxWidth: this.props.width} : {maxWidth : this.props.width, height: this.props.height || "auto"}}>
          		<div className="modal-content" style={{width : this.props.width, height: "100%"}} onClick={this.handleModalContentClick}>
            		{this.props.title && <div className="modal-header p-4">
              			<h4 className="modal-title d-flex justify-content-between" style={{width:"100%"}}>
							  <span>
							  	{this.props.title}
							  </span>
							  {
									this.props.titleAction != null ?
										<button type="button" disabled={this.state.processingAction} className="btn btn-sm btn-secondary" onClick={() => {this.disableButtons();this.props.titleAction()} }>
											{this.props.titleText}
										</button>
									:
										null
								}
							</h4>
            		</div> }
            		<div className="modal-body p-4" style={{maxHeight:this.props.height ? "100%" : "70vh", position: "relative", overflow:this.props.overflow? this.props.overflow: "auto"}}>
						{
							this.state.processingAction && !this.props.noProcessingLoading ?
								<i>
									{this.props.data.t.read("please_wait")}...
								</i>
							:
								this.props.children
						}
            		</div>
            		{ this.buttonCount > 0 && <div className={`modal-footer d-flex px-4 ${this.buttonCount === 1 ? 'justify-content-center' : 'justify-content-between'}`}>
						{
							this.props.cancelAction != null && this.props.cancelText != null ?
								<button type="button" disabled={this.state.processingAction && !this.props.noProcessingLoading} className="btn btn-outline-dark" onClick={() => {this.props.cancelAction()} }>{this.props.cancelText}</button>
							:
								null
						}
						{
							this.props.secondaryAction!= null ?
								<button type="button" disabled={this.state.processingAction} className="btn btn-secondary" onClick={() => {this.disableButtons();this.props.secondaryAction()} }>{this.props.secondaryText}</button>
								:
								null
						}
						{
							this.props.secondaryActions != null ?
								<div className={"d-flex  justify-content-between"}>
									{
										this.props.secondaryActions.map((button, index) =>
											(<button type="button" key={index} disabled={button.disabled != null ? button.disabled : this.state.processingAction}
													 className={button.className || "btn btn-secondary mx-1"} onClick={() => {
													if (!button.noAutoDisable) this.disableButtons();
													button.action()
												}}>{button.text}</button>
											))
									}
								</div>
								:
								null
						}
						{
							this.props.okAction != null ?
								<button type="button" disabled={(!this.props.noProcessingLoading && this.state.processingAction) || this.props.invalid} className="btn btn-primary" onClick={() => {this.processOk()} }>{this.props.okText}</button>
							:
								null
						}
						{
							this.props.okIsSubmit ?
								<button type="submit" disabled={(!this.props.noProcessingLoading && this.state.processingAction)} className="btn btn-primary">{this.props.okText}</button>
							:
								null
						}
            		</div>}
          		</div>
        	</div>
	    </div>
    }
}));
